import { Duration, LocalDateTime } from "@js-joda/core";
import {
  PatientTaskInstanceWithVisit,
  PublicOnboardingVisitDetails,
  PublicVisitBroadcastDetails,
  PublicVisitInstanceDetails,
  VisitInstanceDetails,
} from "../messages";
import { Patient } from "../system/AppState/AppPatientsState";
import { Visit } from "../system/AppState/AppVisitsState";
import { KeyedList } from "./ListImpl";
import { getScheduleFromTime } from "./taskUtils";

export function getClosestVisit(visits: KeyedList<VisitInstanceDetails, "id">) {
  return visits
    .map((visit) => ({
      data: visit,
      compare: Duration.between(LocalDateTime.now(), visit.startTimeLocal).abs(),
    }))
    .sortBy((x) => x.compare.toMillis())
    .first();
}

export function filterVisit(
  visit: PublicVisitBroadcastDetails | PublicOnboardingVisitDetails | PublicVisitInstanceDetails,
  filters: {
    patient: Patient | null;
    boroughs: string[];
    patientSchedule: string[];
    visitTypes: string[];
  }
) {
  if (filters.patient && visit.patientId !== filters.patient.id) return false;

  if (
    filters.boroughs.length > 0 &&
    !filters.boroughs.includes(visit.location.sublocalityLevel1 ?? "")
  )
    return false;

  const visitSchedule = getScheduleFromTime(visit.startTimeLocal.toLocalTime());

  if (filters.patientSchedule.length > 0 && !filters.patientSchedule.includes(visitSchedule))
    return false;

  if (filters.visitTypes.length > 0 && !filters.visitTypes.includes("HHA/PCA Visit")) return false;

  return true;
}

export function isVisitPreferenceMismatch(visit: Visit): boolean {
  return (
    visit.type === "Available" &&
    visit.publicVisitBroadcastDetails.preferenceMismatchReasons.length > 0
  );
}

export type CicoModalEntity =
  | {
      type: "visit";
      visit: VisitInstanceDetails;
    }
  | {
      type: "task";
      task: PatientTaskInstanceWithVisit;
    };

export function extractVisitFromCicoModalEntity(entity: CicoModalEntity): VisitInstanceDetails {
  switch (entity.type) {
    case "task":
      return entity.task.visitInstance;

    case "visit":
      return entity.visit;
  }
}
